import { combineReducers } from 'redux'
import downloadAgendasReducer, { downloadAgendasActions } from '@app-store/slices/reporting/downloadAgendas'
import sendAgendasReducer, { sendAgendasActions } from '@app-store/slices/reporting/sendAgendas'
import sendTestAgendasReducer, { sendTestAgendasActions } from '@app-store/slices/reporting/sendTestAgendas'
import eventReportReducer, { eventReportActions } from '@app-store/slices/reporting/eventReport'
import linkedinEnrichReducer, { linkedinEnrichActions } from '@app-store/slices/reporting/linkedinEnrich'
import scrapeReportReducer, { scrapeReportActions } from '@app-store/slices/reporting/scrapeReport'
import auditTrailReportReducer, { auditTrailReportActions } from '@app-store/slices/reporting/auditTrailReport'

export const reportingReducers = combineReducers({
    downloadAgendas: downloadAgendasReducer,
    sendAgendas: sendAgendasReducer,
    eventReport: eventReportReducer,
    sendTestAgendas: sendTestAgendasReducer,
    linkedinEnrich: linkedinEnrichReducer,
    scrapeReport: scrapeReportReducer,
    auditTrailReport: auditTrailReportReducer
})

export const reportingActions = {
    downloadAgendas: downloadAgendasActions,
    sendAgendas: sendAgendasActions,
    eventReport: eventReportActions,
    sendTestAgendas: sendTestAgendasActions,
    linkedinEnrich: linkedinEnrichActions,
    scrapeReport: scrapeReportActions,
    auditTrailReport: auditTrailReportActions
}
